import { memo } from "react"

type Row = {
  fleets: {
    name: string
  }[]
}

type UserFleetPermission = {
  row: Row
}

const UserFleetColumn = memo(({ row }: UserFleetPermission) => {
  return row?.fleets.map((fleet) => fleet.name).join(', ')
})

export default UserFleetColumn
